module.exports = __webpack_public_path__ + "img/message-center.b559a574.svg";